import React from 'react';
import {
  Box,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
} from '@mui/material';

const RM_first = () => {
  return (
    <Box
      sx={{
        width: '95%',
        py: 2,
        display: 'flex',
        gap: 2,
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600} sx={{ color: '#242424' }} >
          Primary Research
        </Typography>
        <Typography variant="body2" mt={1}>
          We engage directly with stakeholders across the value chain to gather authentic market dynamics.
        </Typography>

        <Grid container spacing={2} mt={1}>
          <Grid item xs={6}>
            <Typography variant="subtitle2" fontWeight={600}>
              Who We Talk To:
            </Typography>
            <List dense disablePadding>
              {[
                'Engineers, product managers, and technical experts',
                'Policy makers and regulatory officials',
                'Distributors, retailers, and procurement heads',
                'Academics, economists, and consultants',
              ].map((text, idx) => (
                <ListItem key={idx} disableGutters>
                  <ListItemText primary={`• ${text}`} />
                </ListItem>
              ))}
            </List>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="subtitle2" fontWeight={600}>
              How We Engage:
            </Typography>
            <List dense disablePadding>
              {[
                'In-depth interviews (telephonic, virtual, on-site)',
                'Focus groups and expert panels',
                'Digital surveys and structured questionnaires',
              ].map((text, idx) => (
                <ListItem key={idx} disableGutters>
                  <ListItemText primary={`• ${text}`} />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>

        <Typography variant="body2" mt={1}>
          These engagements help us uncover insights around investment trends, consumer behavior, technology adoption, and regulatory environments.
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          p: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600} sx={{ color: '#242424' }} >
          Secondary Research
        </Typography>
        <Typography variant="body2" mt={1}>
          We validate and enrich findings using only credible, impartial public sources, ensuring factual integrity.
        </Typography>

        <Typography variant="subtitle2" fontWeight={600} mt={1}>
          Key Sources Include:
        </Typography>
        <List dense disablePadding>
          {[
            'Institutional Reports: World Bank, IMF, Eurostat, WTO, UN Comtrade',
            'Academic Databases: JSTOR, Springer, IEEE, ScienceDirect, PubMed',
            'Think Tank Studies: RAND, Brookings, NREL, OECD',
            'Global Media: Reuters, Bloomberg, The Economist, Financial Times',
            'Regulatory Bodies: FDA, REACH, BIS, RoHS, EPA, ISO',
          ].map((text, idx) => (
            <ListItem key={idx} disableGutters>
              <ListItemText primary={`• ${text}`} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default RM_first
